import { render } from "./IncomeAccounting.vue?vue&type=template&id=7b0dc028&scoped=true"
import script from "./IncomeAccounting.vue?vue&type=script&lang=js"
export * from "./IncomeAccounting.vue?vue&type=script&lang=js"

import "./IncomeAccounting.vue?vue&type=style&index=0&id=7b0dc028&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0dc028"]])

export default __exports__